import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    requisitionId: z.string(),
  }),
  response: z.void(),
};
